import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";
import { FaGreaterThan } from "react-icons/fa6";
import { GoArrowRight } from "react-icons/go";
import { getServiceDetails, needHelpCallBack } from "../../api/api";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
import { useState } from "react";
import { useEffect } from "react";
import { getServicelist } from "../../api/api";
// import '../serviceStyle/DiagnosticServices.css'
import storedServiceList from "../../DB/ServiceData";
import { Link } from "react-router-dom";
import CustomLoader from "../../common/loader/CustomLoader";
import toast from "react-hot-toast";

export default function DiagnosticServicesPage() {
  const [serviceList, setServiceLIst] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("Cardiology");
  const [serviceDetails, setServiceDetails] = useState([]);

  // run the api calling function
  useEffect(() => {
    fetchServicelist();
  }, []);

  const [payload, setPayload] = useState({
    phone_number: "",
    first_name: "",
    email: "",
    comment: "",
  });

  // const [message, setMessage] = useState("");
  // const [loading, setLoading] = useState(false);

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  // submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call your existing API function
    await fetchNeedHelpCallBack(payload);
  };

  console.log("payload==>", payload);

  // call needhelpcallback api
  const fetchNeedHelpCallBack = async (payload) => {
    try {
      setLoading(true);

      const res = await needHelpCallBack(payload);

      if (res?.data?.status?.toLowerCase() === "success") {
        toast.success(res?.data?.message || "Request submitted successfully!");
        setPayload({
          first_name: "",
          phone_number: "",
          email: "",
          comment: "",
        }); // reset form
      } else {
        console.log("API returned failure:", res?.data);
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting help request:", err);
      toast.error("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  // function to calling the getServicelist api
  const fetchServicelist = async () => {
    const payload = {};
    try {
      setLoading(true);
      const res = await getServicelist(payload);
      if (res?.data?.status === "success") {
        const apiData = res?.data?.data || [];

        if (apiData.length > 0) {
          //fetch data in Servicelist

          setServiceLIst(apiData);
          setMessage(""); // clear message when data found
        } else {
          // set empty array when data not found
          setServiceLIst([]);
          setMessage("No data found"); // set message when data not found
        }
      } else {
        setServiceLIst([]);
        setMessage("Problem on API");
      }

      console.log("res.data===>", res?.data);
    } catch (error) {
      console.log("fetching error ", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("serviceList===>", serviceList);

  return (
    <>
      <style>{`
            .test-image {
  margin-top: 50px;   /* adjust value as needed */
}

.test-content {
  align-items: flex-start !important;
}
      `}</style>

      <ServiceHeader
        childClass="diagnosticServicesBGSection"
        breadcrumb={
          <>
            Services <FaGreaterThan size={15} /> Diagnostic Services
          </>
        }
        title="Diagnostic Services"
      />

      {loading && <CustomLoader />}

      <div className="serviceBody-wrapper">
        <div className="right-content">
          <>
            <h2 className="section-heading">About Diagnostic Services</h2>

            {serviceList
              .filter((item) => item.flag === "active")
              .map((service, i) => (
                <section className="test-details-block" key={service.Id}>
                  <div
                    className={`test-content ${
                      i % 2 === 0 ? "normal" : "reverse"
                    }`}
                  >
                    <div className="test-text">
                      <h3 className="test-title rb-headingTag service-headingTag">
                        {service.title}
                      </h3>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: service.description,
                        }}
                        style={{ fontSize: "14px", color: "#555" }}
                      />

                      {/* add see more  */}

                      <Link
                        to={`/service/${encodeURIComponent(service.title)}`}
                        style={{
                          color: "#007bff",
                          textDecoration: "none",
                          fontWeight: "bold",
                          fontSize: "16px",
                          marginTop: "10px",
                          display: "inline-block",
                          transition: "color 0.3s ease",
                        }}
                      >
                        See More →
                      </Link>
                    </div>
                    <div className="test-image">
                      <img src={service.image} alt={service.title} />
                    </div>
                  </div>
                </section>
              ))}
          </>
        </div>

        {/* Sidebar (Other Services + Consultation) */}

        <div className="left-sidebar">
          {/* service box  */}
          <div className="services-box">
            <h4>Other </h4>
            <ul>
              {Object.keys(storedServiceList).map((key, index) => (
                <li key={index}>
                  <Link to={`/service/${key.toLowerCase()}`}>
                    {key}{" "}
                    <span className="arrow">
                      <GoArrowRight size={18} />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* book consultant  */}

          <div className="consult-box">
            <h4>Book a Consultation:</h4>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="first_name"
                placeholder="Full Name"
                value={payload.first_name}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone_number"
                placeholder="Enter Phone"
                value={payload.phone_number}
                onChange={handleChange}
                required
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10);
                }}
              />
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                value={payload.email}
                onChange={handleChange}
                required
              />
              <select
                name="comment"
                value={payload.comment}
                onChange={handleChange}
                required
              >
                <option value="">Select Service</option>
                {Object.keys(storedServiceList).map((key, index) => (
                  <option key={index} value={key.toLowerCase()}>
                    {key}
                  </option>
                ))}
              </select>
              <button type="submit" disabled={loading}>
                {loading ? "Submitting..." : "Book Online"}
                {/* Book Online */}
              </button>
            </form>
          </div>
        </div>
        {/* sidber end  */}
      </div>

      {/* <ServiceBody
                serviceName="Diagnostic Services"
            /> */}
      <ServiceSection />
      <ConsultSection />
    </>
  );
}
